import { render, staticRenderFns } from "./UploadPopular.vue?vue&type=template&id=4b24b6fe&scoped=true&"
import script from "./UploadPopular.vue?vue&type=script&lang=js&"
export * from "./UploadPopular.vue?vue&type=script&lang=js&"
import style0 from "./UploadPopular.vue?vue&type=style&index=0&id=4b24b6fe&lang=scss&scoped=true&"
import style1 from "./UploadPopular.vue?vue&type=style&index=1&id=4b24b6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24b6fe",
  null
  
)

export default component.exports